import React from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Privacy() {
  return <LegalPage kind="privacy" />;
}
